export default {
  data: () => ({
    menus: [
      {
        id: 1,
        name: 'Artigos',
        icon: 'library_books',
        route: '/artigos'
      },
      {
        id: 2,
        name: 'Imagens',
        icon: 'perm_media',
        route: '/imagens'
      },
      {
        id: 3,
        name: 'Links',
        icon: 'attach_file',
        route: '/links'
      },
      {
        id: 4,
        name: 'Tags',
        icon: 'receipt',
        route: '/tags'
      },
      // {
      //   id: 1,
      //   name: 'Blog',
      //   icon: '',
      //   route: '',
      //   submenu: [
      //     {
      //       id: 1.1,
      //       name: 'Artigos',
      //       icon: 'library_books',
      //       route: '/artigos'
      //     },
      //     {
      //       id: 1.3,
      //       name: 'Imagens',
      //       icon: 'perm_media',
      //       route: '/imagens'
      //     },
      //     {
      //       id: 1.4,
      //       name: 'Links',
      //       icon: 'attach_file',
      //       route: '/links'
      //     },
      //     {
      //       id: 1.5,
      //       name: 'Tags',
      //       icon: 'receipt',
      //       route: '/tags'
      //     }
      //   ]
      // },
      // {
      //   id: 2,
      //   name: 'Estatísticas',
      //   icon: 'fingerprint',
      //   route: '/',
      //   submenu: [
      //     {
      //       id: 2.1,
      //       name: 'Cliques',
      //       icon: 'fingerprint',
      //       route: '/cliques'
      //     },
      //     {
      //       id: 2.2,
      //       name: 'Likes',
      //       icon: 'thumb_up',
      //       route: '/likes'
      //     },
      //     {
      //       id: 2.3,
      //       name: 'Compartilhamentos',
      //       icon: 'share',
      //       route: '/compartilhamentos'
      //     }
      //   ]
      // },
      // {
      //   id: 5,
      //   name: 'Configurações',
      //   icon: 'settings',
      //   route: '',
      //   submenu: [
      //     {
      //       id: 5.1,
      //       name: 'Ajuda',
      //       icon: 'help',
      //       route: '/ajuda'
      //     },
      //     {
      //       id: 5.2,
      //       name: 'Sobre',
      //       icon: 'info_outline',
      //       route: '/sobre'
      //     },
      //     {
      //       id: 5.3,
      //       name: 'Licença de Uso',
      //       icon: 'lightbulb_outline',
      //       route: '/licenca'
      //     },
      //     {
      //       id: 5.4,
      //       name: 'Parâmetros do Sistema',
      //       icon: 'chrome_reader_mode',
      //       route: '/parametros'
      //     }
      //   ]
      // },
      // {
      //   id: 96,
      //   name: 'Suporte-Técnico',
      //   icon: 'mood_bad',
      //   route: '/suporte'
      // },
      {
        id: 98,
        name: 'Logout',
        icon: 'lock',
        route: '/'
      },
      {
        id: 99,
        name: 'Sair',
        icon: 'exit_to_app',
        route: '/'
      }
      // {
      //   id: 94,
      //   name: 'Ex Vuetify',
      //   icon: 'exit_to_app',
      //   route: '/vuetify'
      // },
      // {
      //   id: 95,
      //   name: 'Ex Buefy',
      //   icon: 'exit_to_app',
      //   route: '/buefy'
      // }
    ]
  })
}
